import Cookies from "js-cookie";
import { toast } from "sonner";

import { instance, pathname } from "store/reducers/ActionCreators";
let isSendingAlert = false; 
export default async function Error(text: string) {
    
    const safeText = String(text || "").slice(0, 200);
    const accessToken = Cookies.get("access");
    toast.error(safeText, {
        duration: Infinity,
        style: {
            background: "white",
            border: "1px solid #ff4d4f",
            borderRadius: "4px",
            boxShadow:
                "0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05)",
            padding: "12px 16px",
            fontSize: "14px",
            color: "rgba(0, 0, 0, 0.88)",
        },
    });
    if (isSendingAlert) return;
    if (!accessToken) return;
    isSendingAlert = true;
    try {
        await instance.post(
            pathname + "/api/web_alerts",
            { text: safeText, level: "error" },
            {
                headers: {
                    "Content-Type": "application/json",
                    ...(accessToken && {
                        Authorization: `Bearer ${accessToken}`,
                    }),
                },
            }
        );
    } catch (error) {
        console.warn("Ошибка отправки web alert:", error);
    } finally {
        isSendingAlert = false;   
    }
}
